'use client';

import { useQuery } from '@tanstack/react-query';
import { getUser } from '@/app/actions';

interface PhoneNumberDisplayProps {
  advertisement: any; // Replace 'any' with the actual type of your advertisement object
}

const PhoneNumberDisplay = ({ advertisement }: PhoneNumberDisplayProps) => {
  const { data: id } = useQuery({
    queryKey: ['user'],
    queryFn: () => getUser(),
  });

  if (
    id
  ) {
    return (
      <details className="mt-4 mb-6">
        <summary className="cursor-pointer text-primary hover:underline">
          Phone Number
        </summary>
        <a
          href={`tel:${advertisement.expand?.user?.phoneNumber}`}
          className="text-sm mt-2"
        >
          {advertisement.expand?.user?.phoneNumber}
        </a>
      </details>
    );
  }

  return null;
};

export default PhoneNumberDisplay;
